import { useQuery } from '@tanstack/react-query';
import CatalogService from '@utility/services/catalog';
import {
  ALL_SOURCES,
  buildMappableParams,
  initialMappableFilter,
  type SourceFilter,
} from '../lib/mappable-params';
import { catalogMappingKeys } from '../lib/query-keys';
import type { MappingState } from '../lib/types';

/*
 * How many listings of the account are in a state (and of a source kind),
 * the same total the listings table shows. One row is enough: the count is
 * the page's total_data. Undefined while it loads or when it failed. The key
 * sits inside mappableLists(), so saving a mapping refreshes it.
 */
export function useListingTotal(
  state: MappingState,
  source: SourceFilter = ALL_SOURCES,
  enabled = true,
): number | undefined {
  const params = buildMappableParams(state, {
    ...initialMappableFilter(''),
    source,
    limit: 1,
  });
  const query = useQuery({
    queryKey: catalogMappingKeys.listingTotal(params),
    queryFn: () => CatalogService.getMappableListings(params),
    select: page => page.total_data,
    enabled,
  });

  return query.isError ? undefined : query.data;
}

/* How many listings of the account are unmapped, the same total the Unmatched tab shows. */
export const useUnmappedCount = (enabled = true) =>
  useListingTotal('unmapped', ALL_SOURCES, enabled);
